import { PayloadAction } from '@reduxjs/toolkit';

import { ErrorPayload, DataPayload, ActionTypes, QueryState } from '../types/state';

export const queryInitialState = {
  isLoading: false,
  isSuccess: false,
  errors: [],
  data: undefined,
};

export const onQueryStart = <T, S extends QueryState<T>>(state: S): S => ({
  ...state,
  isSuccess: false,
  isLoading: true,
  errors: [],
});

export const onQueryError = <T, S extends QueryState<T>>(state: S, action: PayloadAction<ErrorPayload>): S => ({
  ...state,
  isSuccess: false,
  isLoading: false,
  errors: action.payload.errors,
});

export const onQuerySuccess = <T, S extends QueryState<T>>(state: S, action: PayloadAction<DataPayload<T>>): S => ({
  ...state,
  isLoading: false,
  isSuccess: true,
  data: action.payload.data,
});

export const queryHandlers = (actionTypes: ActionTypes) => ({
  [actionTypes.START]: onQueryStart,
  [actionTypes.SUCCESS]: onQuerySuccess,
  [actionTypes.ERROR]: onQueryError,
});
